import React from 'react';
import { TextField } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import { useFormOperations } from '../../hooks/useFormOperations';
import { inputStyles } from '../styles';
import { useFormContext } from '../../context/FormContext';
import useAlias from '@src/hooks/useAlias';

interface NameFieldProps {
  type: 'template' | 'stack';
}

const NameField: React.FC<NameFieldProps> = ({ type }) => {
  const alias = useAlias();
  const { name, setName } = useFormOperations();
  const { state } = useFormContext();
  const { hasAttemptedSubmit } = state;

  const typeLabel = type === 'template' ? alias('Template') : alias('Stack');

  return (
    <Grid2 size={12} sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label={alias('{type} Name', { type: typeLabel })}
        value={name}
        onChange={(e) => setName(e.target.value)}
        variant='outlined'
        size='small'
        required
        error={hasAttemptedSubmit && !name.trim()}
        helperText={
          hasAttemptedSubmit && !name.trim()
            ? alias('{type} name is required', { type: typeLabel })
            : ''
        }
        sx={inputStyles}
      />
    </Grid2>
  );
};

export default NameField;
